/**
 * ClassAppointmentCard — Card de resumo para agendamentos de turma (group scheduling)
 * 
 * Exibe informações agregadas de um grupo de appointments no mesmo slot:
 * - Capacidade e ocupação em barra de progresso
 * - Contagem de confirmados e pendentes
 * - Nome da agenda e horário do slot
 * - Badge "Turma" para diferenciação visual
 * 
 * NÃO revela nomes dos participantes (apenas agregados); detalhes em ClassDetailsModal
 */

import { Box, Typography, Chip, LinearProgress } from '@mui/material';
import { formatTime } from '../utils/formatters';

export default function ClassAppointmentCard({ group, onClick }) {
  const occupied = group.items.length;
  const capacity = group.schedule?.maxAttendees ?? 1;
  const pctOccupied = (occupied / capacity) * 100;

  const confirmed = group.items.filter(a => a.confirmedAt && !a.cancelledAt).length;
  const pending = occupied - confirmed;

  return (
    <Box
      onClick={() => onClick?.(group)}
      sx={{
        p: 1,
        mb: 1,
        borderRadius: 1,
        border: '2px solid',
        borderColor: 'primary.light',
        bgcolor: 'primary.lighter',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': {
          boxShadow: onClick ? 2 : 0,
          borderColor: onClick ? 'primary.main' : 'primary.light',
        },
      }}
    >
      {/* Header: Nome da agenda + Badge Turma */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle2" fontWeight="bold" noWrap>
          {group.schedule?.name || 'Agenda'}
        </Typography>
        <Chip size="small" label="Turma" color="primary" variant="outlined" />
      </Box>

      {/* Horário do slot */}
      <Typography variant="body2" color="text.secondary">
        {formatTime(group.slot)}
      </Typography>

      {/* Barra de progresso e estatísticas */}
      <Box mt={1}>
        <LinearProgress
          variant="determinate"
          value={Math.min(pctOccupied, 100)}
          sx={{ height: 8, borderRadius: 1 }}
        />
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
          {occupied}/{capacity} inscritos · {confirmed} confirmados · {pending} pendentes
        </Typography>
      </Box>
    </Box>
  );
}
